<div class="content-wrapper" style="height:100%;">
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid"></div>
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <!--<app-home></app-home>-->
            <router-outlet></router-outlet>
        </div><!--/. container-fluid -->
    </section>
    <!-- /.content -->
</div>
